import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../primitives/LoadingAnimation/components/Container.js';
import { Dot } from '../../primitives/LoadingAnimation/components/Dot.js';
/**
 * Our default loading animation.
 *
 * If needed you can adjust the `size`, `color` and `margin`.
 * For most cases you should be able to rely on the default values.
 *
 * Adjusting the speed of the animation via the `speedMultiplier`
 * will change the speed of the animation which actually is
 * discouraged and only exist as a compatibility layer to
 * the `react-spinners` library we used in the past.
 */
export const LoadingAnimation = /*#__PURE__*/_styled(({
  size,
  color,
  margin,
  speedMultiplier,
  ...restProps
}) => {
  return _jsxs(Container, {
    ...restProps,
    children: [_jsx(Dot, {
      size: size,
      color: color,
      margin: margin,
      speedMultiplier: speedMultiplier,
      delay: 0.07
    }), _jsx(Dot, {
      size: size,
      color: color,
      margin: margin,
      speedMultiplier: speedMultiplier,
      delay: 0.14
    }), _jsx(Dot, {
      size: size,
      color: color,
      margin: margin,
      speedMultiplier: speedMultiplier,
      delay: 0.21
    })]
  });
}, process.env.NODE_ENV === "production" ? {
  target: "ephrkue0"
} : {
  target: "ephrkue0",
  label: "LoadingAnimation"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvYWRpbmdBbmltYXRpb24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBaUJHIiwiZmlsZSI6IkxvYWRpbmdBbmltYXRpb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCwganN4cyBhcyBfanN4cyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgQ29udGFpbmVyIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9Mb2FkaW5nQW5pbWF0aW9uL2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmltcG9ydCB7IERvdCB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvTG9hZGluZ0FuaW1hdGlvbi9jb21wb25lbnRzL0RvdC5qcyc7XG4vKipcbiAqIE91ciBkZWZhdWx0IGxvYWRpbmcgYW5pbWF0aW9uLlxuICpcbiAqIElmIG5lZWRlZCB5b3UgY2FuIGFkanVzdCB0aGUgYHNpemVgLCBgY29sb3JgIGFuZCBgbWFyZ2luYC5cbiAqIEZvciBtb3N0IGNhc2VzIHlvdSBzaG91bGQgYmUgYWJsZSB0byByZWx5IG9uIHRoZSBkZWZhdWx0IHZhbHVlcy5cbiAqXG4gKiBBZGp1c3RpbmcgdGhlIHNwZWVkIG9mIHRoZSBhbmltYXRpb24gdmlhIHRoZSBgc3BlZWRNdWx0aXBsaWVyYFxuICogd2lsbCBjaGFuZ2UgdGhlIHNwZWVkIG9mIHRoZSBhbmltYXRpb24gd2hpY2ggYWN0dWFsbHkgaXNcbiAqIGRpc2NvdXJhZ2VkIGFuZCBvbmx5IGV4aXN0IGFzIGEgY29tcGF0aWJpbGl0eSBsYXllciB0b1xuICogdGhlIGByZWFjdC1zcGlubmVyc2AgbGlicmFyeSB3ZSB1c2VkIGluIHRoZSBwYXN0LlxuICovXG5leHBvcnQgY29uc3QgTG9hZGluZ0FuaW1hdGlvbiA9IHN0eWxlZCgoeyBzaXplLCBjb2xvciwgbWFyZ2luLCBzcGVlZE11bHRpcGxpZXIsIC4uLnJlc3RQcm9wcyB9KSA9PiB7XG4gICAgcmV0dXJuIChfanN4cyhDb250YWluZXIsIHsgLi4ucmVzdFByb3BzLCBjaGlsZHJlbjogW19qc3goRG90LCB7IHNpemU6IHNpemUsIGNvbG9yOiBjb2xvciwgbWFyZ2luOiBtYXJnaW4sIHNwZWVkTXVsdGlwbGllcjogc3BlZWRNdWx0aXBsaWVyLCBkZWxheTogMC4wNyB9KSwgX2pzeChEb3QsIHsgc2l6ZTogc2l6ZSwgY29sb3I6IGNvbG9yLCBtYXJnaW46IG1hcmdpbiwgc3BlZWRNdWx0aXBsaWVyOiBzcGVlZE11bHRpcGxpZXIsIGRlbGF5OiAwLjE0IH0pLCBfanN4KERvdCwgeyBzaXplOiBzaXplLCBjb2xvcjogY29sb3IsIG1hcmdpbjogbWFyZ2luLCBzcGVlZE11bHRpcGxpZXI6IHNwZWVkTXVsdGlwbGllciwgZGVsYXk6IDAuMjEgfSldIH0pKTtcbn0pIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9TG9hZGluZ0FuaW1hdGlvbi5qcy5tYXAiXX0= */");